import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { hiddenLoader } from "../stores/loading";
import { fetchAPI } from "../utils/api";
import { addNotification } from "../utils/Utils";

export default function User() {
    const dispatch = useDispatch();
    let [searchParams, setSearchParams] = useSearchParams();
    let [userSearch, setUserSearch] = useState('');
    let [resultUser, setResultUser] = useState({} as any);
    let [newUser, setNewUser] = useState(false);
    let [roleSelected, setRoleSelected] = useState('');
    let [checkDeleteUser, setCheckDeleteUser] =  useState(false);

    const roles: string[] = [
        "ONE_PARTNER",
        "ONE_PAY",
        "MAPPER",
        "READER",
        "TRIAGE",
        "WRITER",
        "SUPPORT",
        "ADMIN"
    ]

    function submitFormUser(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        let formData = new FormData(event.currentTarget);
        setSearchParams({ user: formData.get('user') as string });
        setUserSearch(formData.get('user') as string);
        searchUser(formData.get('user') as any)
    }

    useEffect(() => {
        if (searchParams.get('user') && searchParams.get('user') !== null) {
            setUserSearch(searchParams.get('user') as string);
            searchUser(searchParams.get('user') as any);
        }
        // eslint-disable-next-line 
    }, [])

    function submitNewUser(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        let formData = new FormData(event.currentTarget);
        const newUser = { "username": userSearch, "description": formData.get('description'), "enabled": true, "role": roleSelected };
        createUser(newUser)
    }

    function searchUser(uid: string) {
        setNewUser(false);
        setRoleSelected('');
        fetchAPI(`/users/${uid}`)
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    dispatch(hiddenLoader());
                    return res.json()
                }
                dispatch(hiddenLoader());
                return res;
            })
            .then(setResultUser);
    }

    function changeRole(role: string) {
        if (resultUser && resultUser.status === 404) {
            setRoleSelected(role)
        } else {
            updateUser(role)
        }
    }

    function updateUser(role: string) {
        fetchAPI(`/users/`, {
            method: "PATCH",
            body: JSON.stringify({ ...resultUser, role: role })
        })
            .then((res) => {
                if (res.status === 200 || res.status === 206) {
                    return res.json()
                }
                return res;
            })
            .then((result) => {
                addNotification("success", `${result.username} is updated`)
                setResultUser(result);
                setUserSearch(result.username)
                setNewUser(false);
            },
                error => {
                    addNotification("danger", error)
                });
    }

    function deleteUser(username: string) {
        
        fetchAPI(`/users/${username}`, {
            method: "DELETE"
        })
            .then((res) => {
                if (res.status === 200) {
                    addNotification("success", `${username} is delete`);
                    setResultUser({});
                    setNewUser(false);
                    setUserSearch('');
                    setCheckDeleteUser(false);
                } else {
                    addNotification("danger", `${username}`);
                }
            }
            );
    }

    function createUser(body: any) {
        fetchAPI(`/users/`, {
            method: "POST",
            body: JSON.stringify(body)
        })
            .then((res) => {
                if (res.status === 201) {
                    return res.json()
                }
                return res;
            })
            .then((result) => {
                addNotification("success", `${body.username} is created`)
                setResultUser(result);
                setUserSearch(result.username)
                setNewUser(false);
                setCheckDeleteUser(false);
            },
                error => {
                    addNotification("danger", error)
                });
    }

    return (
        <>
            <div className="vtmn-flex vtmn-justify-center" >
                <form onSubmit={submitFormUser} className="vtmn-flex vtmn-justify-center" id="form-user">
                    <div className="block" key={'user'}>
                        <div className="vtmn-text-input_container vtmn-mt-5 vtmn-mr-2">
                            <input
                                type="text"
                                className="vtmn-text-input"
                                id="user"
                                name="user"
                                placeholder="UID"
                                aria-describedby="overview-input-helper-1"
                                defaultValue={userSearch ?? undefined}
                                disabled={newUser}
                                onChange={() =>{ setUserSearch(''); setResultUser({})}}
                            />
                            <span className="vtmx-search-line" aria-hidden="true"></span>
                        </div>
                    </div>
                    <button className="vtmn-btn vtmn-btn_size--stretched vtmn-mt-5" disabled={newUser || checkDeleteUser} type="submit">Search</button>
                </form>
            </div>
            {userSearch && resultUser && resultUser.status !== 404 && <div className="vtmn-flex vtmn-justify-center vtmn-mt-5">
                <div className="vtmn-text-center">
                    User : {resultUser.description}
                    { !checkDeleteUser && <button className="vtmn-btn vtmn-btn_size--stretched vtmn-btn_variant--tertiary" onClick={() => setCheckDeleteUser(true)}>Delete</button>}
                    {checkDeleteUser && <div className="vtmn-flex vtmn-justify-center vtmn-mt-5  vtmn-items-center">
                       <div className="vtmn-mr-2"> Are you sure ?</div>
                    <button className="vtmn-btn " onClick={() => deleteUser(resultUser.username)}>Yes</button>
                    <button className="vtmn-btn vtmn-btn_variant--tertiary" onClick={() => setCheckDeleteUser(false)}>No</button>
                    </div>}
                </div>
            </div>}
            {resultUser && resultUser.status === 404 && <div className="vtmn-flex vtmn-justify-center vtmn-mt-5">
                <div className="vtmn-text-center">
                    <span>User not found </span>
                    {!newUser && <button className="vtmn-btn vtmn-mt-5" onClick={() => setNewUser(true)}>Create User : {userSearch}</button>}
                    {newUser && <form onSubmit={submitNewUser} className="vtmn-flex vtmn-justify-center" id="form-new-user">
                        <div className="block" key={'user'}>
                            <div className="vtmn-text-input_container vtmn-mt-5 vtmn-mr-2">
                                <input
                                    type="text"
                                    className="vtmn-text-input"
                                    id="description"
                                    name="description"
                                    placeholder="description"
                                    aria-describedby="overview-input-helper-1"
                                />
                            </div>
                        </div>
                        <button
                            className="vtmn-btn vtmn-btn_size--stretched vtmn-mt-5"
                            disabled={!roleSelected || checkDeleteUser}
                            type="submit">Save</button>
                    </form>}
                </div>
            </div>}

            {!checkDeleteUser && userSearch && resultUser && <div className="block vtmn-grid vtmn-grid-cols-4 vtmn-mt-5 vtmn-gap-0" style={{ width: '50%', margin: 'auto', marginTop: '30px' }}>
                {roles.map(role => {
                    return (
                        <div
                            key={role}
                            className={`vtmn-chip vtmn-chip_variant--single-choice vtmn-m-2 `}
                            style={{ maxWidth: 'none' }}
                            role="button"
                            aria-pressed={resultUser.role === role || roleSelected === role}
                            onClick={() => changeRole(role)}
                        >
                            {role}
                        </div>
                    )
                })}
            </div>}
        </>
    )
}